import React, { useEffect, useMemo, useState } from 'react';

import { Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import ErrorCard from '../../../../../shared/components/v3/Cards/ErrorCard/ErrorCard';
import SelectionCard from '../../../../../shared/components/v3/Cards/SelectionCard/SelectionCard';
import { CREATE_CHALLENGE_SKELETON_COUNT } from '../../../../../shared/constants/challenges';
import { ISelectChallengeProps } from '../../../../../shared/interfaces/challenges';
import { TRANSLATIONS_GLOBAL } from '../../../../../shared/translations/commons';
import './SelectChallenge.scss';

const SelectChallenge = ({
  selectedChallengeInfo,
  challengesInfo,
  loading,
  error,
  setSelectedCategory,
  retry
}: ISelectChallengeProps) => {
  const [selected, setSelected] = useState<number>();

  const { t } = useTranslation();

  const handleChange = (index: number) => {
    setSelected(index);
    setSelectedCategory(challengesInfo[index]);
  };

  const renderSkeletons = useMemo(
    () =>
      new Array(CREATE_CHALLENGE_SKELETON_COUNT)
        .fill(0)
        .map((_, i) => <Skeleton key={i} className="challenge-card-skeleton" variant="rectangular" />),
    []
  );

  useEffect(() => {
    if (selectedChallengeInfo) {
      setSelected(challengesInfo.findIndex((challenge) => challenge.title === selectedChallengeInfo.title));
    }
  }, [selectedChallengeInfo, challengesInfo]);

  if (loading) {
    return <div className="challenges-selection">{renderSkeletons}</div>;
  }

  if (error) {
    return (
      <div className="create-challenge-content">
        <ErrorCard
          primaryText={t(TRANSLATIONS_GLOBAL.errorCard.title)}
          secondaryText={t(TRANSLATIONS_GLOBAL.errorCard.description)}
          action={retry}
          center={true}
          className="challenge-selection-error-card"
          buttonText={t(TRANSLATIONS_GLOBAL.errorCard.buttonText)}
        />
      </div>
    );
  }

  return (
    <div className="challenges-selection">
      {challengesInfo.map((challenge, index) => {
        return (
          <SelectionCard
            name="select-challenge"
            type="challenges-card"
            onChange={() => handleChange(index)}
            selected={selected === index}
            value="value"
            description={challenge.description}
            title={challenge.title}
            pictogram={{ url: challenge.icon }}
            key={challenge.title}
          />
        );
      })}
    </div>
  );
};

export default React.memo(SelectChallenge);
